import Area, { AreaInitializer } from './Area';
import MerchantCategory, {
  MerchantCategoryInitializer,
} from './MerchantCategory';

export default class ExploreArea {
  public readonly area: Area;
  public readonly merchantCategory: MerchantCategory;
  public readonly merchantCount: number;

  constructor(init: ExploreAreaInitializer) {
    this.area = new Area(init.area);
    this.merchantCategory = new MerchantCategory(init.merchantCategory);
    this.merchantCount = init.merchantCount;
  }
}

export interface ExploreAreaInitializer {
  area: AreaInitializer;
  merchantCategory: MerchantCategoryInitializer;
  merchantCount: number;
}
